import { render, staticRenderFns } from "./DraftBox.vue?vue&type=template&id=c52ab37e&scoped=true"
import script from "./DraftBox.vue?vue&type=script&lang=js"
export * from "./DraftBox.vue?vue&type=script&lang=js"
import style0 from "./DraftBox.vue?vue&type=style&index=0&id=c52ab37e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52ab37e",
  null
  
)

export default component.exports